import { TabMenu } from 'primereact/tabmenu';
import { TabPanel, TabView } from 'primereact/tabview';
import React, { useEffect } from 'react';
import { Card, Container } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import AddUpdateShg from './AddUpdateShg';
import { ListView } from '../../layout/ListView';
import AddUpdateItem from './AddUpdateItem';

const ShgDetailsNavigation = () => {
    const navigate = useNavigate();
    const { id, type, action, itemId } = useParams();
    console.log("🚀 ~ ShgDetailsNavigation ~ type, action:", type, action, itemId)

    const dispatch = useDispatch()

    const menuItems = [
        {
            label: 'SHG Details', icon: 'pi pi-home',
            command: () => {
                navigate(`/shgadmin/shg/${id}/shg/update/`)
            }
        },
        {
            label: 'SHG Banking', icon: 'pi pi-chart-line',
            command: () => {
                navigate(`/shgadmin/shg/${id}/shg_banking/list/`)
            }
        },
        {
            label: 'SHG Interlending', icon: 'pi pi-list',
            command: () => {
                navigate(`/shgadmin/shg/${id}/shg_interlending/list/`)
            }
        },
        {
            label: 'SHG Governance', icon: 'pi pi-inbox',
            command: () => {
                navigate(`/shgadmin/shg/${id}/shg_governance/list/`)
            }
        },
        {
            label: 'SHG Grading', icon: 'pi pi-inbox',
            command: () => {
                navigate(`/shgadmin/shg/${id}/shg_grading/list/`)
            }
        },
        {
            label: 'SHG Application Tracking', icon: 'pi pi-inbox',
            command: () => {
                navigate(`/shgadmin/shg/${id}/shg_app_tracking/list/`)
            }
        }
    ];

    useEffect(() => {


    }, [type])

    return (
        <Container fluid>
            <Card>
                <TabMenu model={menuItems} pt={{
                    action: {
                        style: {
                            textDecoration: "none",
                        },
                    }
                }} />

                {type === 'shg' && <AddUpdateShg />}
                {type === 'shg_banking' ? (action === 'add' || action === 'update') ? <AddUpdateItem
                    itemId={itemId}
                    navigate_url={{
                        fallback_url: `/shgadmin/shg/${id}/shg_banking/list`
                    }}
                    api_url={{
                        item_url: `shg/${id}/bankings`
                    }}
                /> : <ListView
                    api_url={{
                        list_url: `shg/${id}/bankings/`,
                        delete_url: `shg/${id}/bankings/`,
                    }}
                    navigate_url={{
                        create_url: `/shgadmin/shg/${id}/shg_banking/add`,
                        update_url: `/shgadmin/shg/${id}/shg_banking/update`,
                    }}
                    title="SHG Bankings"
                /> : <></>}

                {type === 'shg_interlending' ? (action === 'add' || action === 'update') ? <AddUpdateItem
                    itemId={itemId}
                    navigate_url={{
                        fallback_url: `/shgadmin/shg/${id}/shg_interlending/list`
                    }}
                    api_url={{
                        item_url: `shg/${id}/interlendings`
                    }}
                /> : <ListView
                    api_url={{
                        list_url: `shg/${id}/interlendings/`,
                        delete_url: `shg/${id}/interlendings/`,
                    }}
                    navigate_url={{
                        create_url: `/shgadmin/shg/${id}/shg_interlending/add`,
                        update_url: `/shgadmin/shg/${id}/shg_interlending/update`,
                    }}
                    title="SHG Bankings"
                /> : <></>}

                {type === 'shg_governance' ? (action === 'add' || action === 'update') ? <AddUpdateItem
                    itemId={itemId}
                    navigate_url={{
                        fallback_url: `/shgadmin/shg/${id}/shg_governance/list`
                    }}
                    api_url={{
                        item_url: `shg/${id}/governance`
                    }}
                /> : <ListView
                    api_url={{
                        list_url: `shg/${id}/governance/`,
                        delete_url: `shg/${id}/governance/`,
                    }}
                    navigate_url={{
                        create_url: `/shgadmin/shg/${id}/shg_governance/add`,
                        update_url: `/shgadmin/shg/${id}/shg_governance/update`,
                    }}
                    title="SHG Governance"
                /> : <></>}

                {type === 'shg_grading' ? (action === 'add' || action === 'update') ? <AddUpdateItem
                    itemId={itemId}
                    navigate_url={{
                        fallback_url: `/shgadmin/shg/${id}/shg_grading/list`
                    }}
                    api_url={{
                        item_url: `shg/${id}/gradings`
                    }}
                /> : <ListView
                    api_url={{
                        list_url: `shg/${id}/gradings/`,
                        delete_url: `shg/${id}/gradings/`,
                    }}
                    navigate_url={{
                        create_url: `/shgadmin/shg/${id}/shg_grading/add`,
                        update_url: `/shgadmin/shg/${id}/shg_grading/update`,
                    }}
                    title="SHG Gradings"
                /> : <></>}

                {type === 'shg_app_tracking' ? (action === 'add' || action === 'update') ? <AddUpdateItem
                    itemId={itemId}
                    navigate_url={{
                        fallback_url: `/shgadmin/shg/${id}/shg_app_tracking/list`
                    }}
                    api_url={{
                        item_url: `shg/${id}/app_trackings`
                    }}
                /> : <ListView
                    api_url={{
                        list_url: `shg/${id}/app_trackings/`,
                        delete_url: `shg/${id}/app_trackings/`,
                    }}
                    navigate_url={{
                        create_url: `/shgadmin/shg/${id}/shg_app_tracking/add`,
                        update_url: `/shgadmin/shg/${id}/shg_app_tracking/update`,
                    }}
                    title="SHG Application Trackings"
                /> : <></>}

            </Card>


        </Container >
    );
};

export default ShgDetailsNavigation;